import React from 'react';
import GenericSetupPage from './GenericSetupPage';

const CBSACodesPage = () => {
  const columns = [
    { key: 'code', label: 'CBSA Code' },
    { key: 'name', label: 'CBSA Name' },
    { key: 'state', label: 'State' },
    { key: 'wageIndex', label: 'Wage Index' },
    { key: 'active', label: 'Active' },
  ];

  const formFields = [
    { key: 'code', label: 'CBSA Code', type: 'text', required: true },
    { key: 'name', label: 'CBSA Name', type: 'text', required: true },
    { key: 'state', label: 'State', type: 'text', required: true },
    { key: 'wageIndex', label: 'Wage Index', type: 'text', required: false },
    { key: 'active', label: 'Active', type: 'select', required: true, options: [
      { value: 'Yes', label: 'Yes' },
      { value: 'No', label: 'No' }
    ]}
  ];

  const initialData = [
    { id: '1', code: '26420', name: 'Houston-The Woodlands-Sugar Land, TX', state: 'TX', wageIndex: '1.0234', active: 'Yes' },
    { id: '2', code: '19100', name: 'Dallas-Fort Worth-Arlington, TX', state: 'TX', wageIndex: '1.0156', active: 'Yes' },
    { id: '3', code: '41700', name: 'San Antonio-New Braunfels, TX', state: 'TX', wageIndex: '0.8756', active: 'Yes' },
    { id: '4', code: '12420', name: 'Austin-Round Rock, TX', state: 'TX', wageIndex: '0.9543', active: 'Yes' },
    { id: '5', code: '99999', name: 'Rural Texas', state: 'TX', wageIndex: '0.7823', active: 'Yes' },
  ];

  return (
    <GenericSetupPage
      title="CBSA Codes"
      columns={columns}
      initialData={initialData}
      addButtonText="Add CBSA"
      formFields={formFields}
      apiEndpoint="/setup/cbsa-codes"
    />
  );
};

export default CBSACodesPage;
